export enum ListViewFilterLayoutElementType {
  Grid = 101,
  Stack = 102,
}